/** 登录态清理：401 或退出登录时调用，不依赖 pinia */
import { removeStorageSync } from '@/utils/storage.js';

/** 登录态相关的 localStorage key */
const AUTH_STORAGE_KEYS = [
	'cmdc_access_token_mobile', // token
	'user_info', // 用户信息（useUserStore）
	'userInfo',
	'user',
	'user_openCode',
	'wxCode',
] as const;

/** 登录态相关的 Cookie key */
const AUTH_COOKIE_KEYS = ['cmdc_access_token_mobile', 'user_info'] as const;

/** 清客户端登录态（localStorage / sessionStorage / Cookie），不跳转 */
export function clearClientAuthStorage() {
	if (!import.meta.client) return;

	AUTH_STORAGE_KEYS.forEach(key => removeStorageSync(key));

	// 历史页面用 sessionStorage.access_token 判断登录态
	try {
		sessionStorage.removeItem('access_token');
	} catch (e) {
		console.error('[authState] clear sessionStorage failed:', e);
	}

	AUTH_COOKIE_KEYS.forEach(key => {
		document.cookie = `${key}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; SameSite=Lax`;
	});
}
